import { useEffect, useState } from 'react';

import { TextField, Autocomplete, Box, Button } from '@mui/material';

import { getConsolidations } from '../api/сonsolidations';
import { updateAsingeIdx, deleteAsingeIdx } from '../api/asingne_idx';

import translations from '../scripts/translations';

const AssignIdx = ({ language, selctedShipementInDataGreed, setSelectedShipementInDataGreed, fetchShipements }) => {


  const [consolidations, setConsolidations] = useState([]);
  const [consolidationId, setConsolidationId] = useState(null);

  const btns = translations.button[language];


  const handelData = () => {
    return {
      consolidation: {
        _id: consolidationId,
        consolidationCode: consolidations.find(item => item.id === consolidationId)?.consolidationCode
      }, shipments: selctedShipementInDataGreed
    }
  }


  const handelAsingneIdx = async () => {

    const rs = await updateAsingeIdx(handelData());
    if (rs) {
      fetchShipements();
      // setSelectedShipementInDataGreed([]);
      // setConsolidationId(null);
      console.log(rs);
    }
    else {
      console.error('Failed to assign shipments to consolidation');
    }

  }

  // const handelDeleteAsingneIdx = async ({consolidation_id, shipment_id}) => {

  //   const rs = await deleteAsingeIdx({consolidation_id, shipment_id});
  //   if (rs) {
  //     // setSelectedShipementInDataGreed([]);
  //     // setConsolidationId(null);
  //     console.log(rs);
  //   }
  //   else {
  //     console.error('Failed to delete assignment of shipments from consolidation');
  //   }
  // }


  useEffect(() => {
    const fetchConsolidations = async () => {
      try {
        const rs = await getConsolidations({});
        if (rs) {
          let consolidationList = rs.map(item => ({
            label: item.consolidationCode,
            id: item._id,
            consolidationCode: item.consolidationCode,
          }));
          setConsolidations(consolidationList);

        } else {
          console.error('No data found in response');
        }
      } catch (error) {
        console.error('Error fetching consolidations:', error);
      }
    };
    fetchConsolidations();
  }, []);

  return (

    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, }}>
      <Autocomplete
        // disablePortal
        options={consolidations}
        sx={{ width: 280 }}
        size='small'
        onChange={(event, newValue) => {
          if (newValue) {
            setConsolidationId(newValue.id);

          } else {
            setConsolidationId(null);

          }
        }}
        renderInput={(params) => <TextField {...params} label={btns.selectConsolidation} />}
      />

      <Button
        variant='outlined'
        disabled={!consolidationId}
        onClick={handelAsingneIdx}
      >
        {btns.asingneToConsolidation}
      </Button>

      {/* <Button
        variant='outlined'
        disabled={!consolidationId}
        onClick={handelDeleteAsingneIdx}
      >
        {btns.clear}
      </Button> */}

    </Box>
  );
}

export default AssignIdx;